<template>
  <div class="information-section">
    <request-info-section
      v-if="entityType === IDENTIFIER_SCOPES.REQUEST"
      :request="entityValue"
    />
    <case-info-section
      v-else-if="entityType === IDENTIFIER_SCOPES.CASE"
      :case-study="entityValue"
    />
    <sample-info-section
      v-else-if="entityType === IDENTIFIER_SCOPES.SAMPLE"
      :sample="entityValue"
    />
    <portion-info-section
      v-else-if="entityType === IDENTIFIER_SCOPES.PORTION"
      :portion="entityValue"
    />
    <subportion-info-section
      v-else-if="entityType === IDENTIFIER_SCOPES.SUBPORTION"
      :subportion="entityValue"
    />
  </div>
</template>

<script>
import RequestInfoSection from './RequestInfoSection'
import CaseInfoSection from './CaseInfoSection'
import SampleInfoSection from './SampleInfoSection'
import PortionInfoSection from './PortionInfoSection'
import SubportionInfoSection from './SubportionInfoSection'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'

export default {
    name: 'InformationSection',
    components: {
        RequestInfoSection,
        CaseInfoSection,
        SampleInfoSection,
        PortionInfoSection,
        SubportionInfoSection
    },
    props: {
        entityType: String,
        entityValue: { type: Object, required: true }
    },
    computed: {
        IDENTIFIER_SCOPES() {
            return IDENTIFIER_SCOPES
        }
    }
}
</script>

<style lang="scss">
    .information-section {
        .not-available {
            font-size: font-size(very-small) !important;
            font-style: italic;
        }

        .info-card {
            border: 1px solid vt-color(light-grey);
            height: 60px;

            .data-card-text {
                line-height: 16px;
            }

            span {
                text-align: center;
                color: vt-color(dark-text);
                font-size: font-size(very-small);
            }

            small {
                text-transform: uppercase;
                font-size: font-size(tiny) !important;
            }
        }
    }
</style>
